import { useContext } from 'react';
import EditorContext from '../store/Editor.context';

var useEditor = function useEditor() {
  var context = useContext(EditorContext);
  return context.state;
};

export default useEditor;